module.exports = __webpack_public_path__ + "static/img/67383df2f916141a979d9e384ec73cd.ca82571.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/67383df2f916141a979d9e384ec73cd.png
// module id = vcT3
// module chunks = 73